const doc = [({"zh_tw":({"labelActivity":({"roomIndex":"體驗{{index}}"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;